import("./bootstrap").then(({ mount }) => {
  const localRoot = document.getElementById("rgm");

  mount({
    mountPoint: localRoot!,
    routingStrategy: "browser",
  });
});

export {};
